import React, { createContext, useContext, useEffect, useState } from 'react'
import { User } from '../../../entities'

const STORAGETOKEN = '@SYGO-CRM-USER'

export interface AuthContextData {
  // isAuthenticated: boolean
  user: User | null
  setUser(user: User | null): void
  logOut(): void
}

export const AuthContext = createContext<AuthContextData>({} as AuthContextData)

// eslint-disable-next-line react/prop-types
export const AuthProvider: React.FC = ({ children }) => {
  const [user, _setUser] = useState<User | null>(null)

  useEffect(() => {
    function loadStorageData() {
      const storageUser = localStorage.getItem(STORAGETOKEN)

      if (storageUser) {
        _setUser(JSON.parse(storageUser))
      }
    }
    loadStorageData()
  }, [])

  function setUser(user: User) {
    if (user === null) {
      localStorage.clear()
    } else {
      _setUser(user)
      localStorage.setItem(STORAGETOKEN, JSON.stringify(user))
    }
  }

  function logOut() {
    _setUser(null)
    localStorage.clear()
  }

  return (
    <AuthContext.Provider
      value={{
        // isAuthenticated: !!localStorage.getItem(STORAGETOKEN),
        user: user,
        setUser,
        logOut
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export const useAuthContext = () => useContext(AuthContext)
